import { useState } from '#app/composables/state';

export const useAccountReturnRouteState = () => useState<string | null>('account-return-route', () => null);
